// tslint:disable:max-line-length
import { Component, ChangeDetectionStrategy, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { WorkFieldDateChangeEvent } from '../../events/work-field-date-change-event';
import { E5coreUiWorkFieldTypeBase } from '../e5core-ui-work-field/e5core-ui-work-field-type-base';
import { UiStyleService } from '../../services/ui-style.service';

@Component({
  selector: 'e5core-ui-work-field-type-date',
  template: `
  <span [ngSwitch]="style.current()">
    <e5core-ui-work-field-type-date-box *ngSwitchCase='0' [workItem$]='workItem$' [date]='date' [field]='field' [property]='property' (valueChange)='valueChange($event)' [readonly]='readonly'></e5core-ui-work-field-type-date-box>
    <e5core-ui-work-field-type-date-bootstrap *ngSwitchCase='1' [workItem$]='workItem$' [date]='date' [field]='field' [property]='property' (valueChange)='valueChange($event)' [readonly]='readonly'></e5core-ui-work-field-type-date-bootstrap>
    <e5core-ui-work-field-type-date-material *ngSwitchCase='2' [workItem$]='workItem$' [date]='date' [field]='field' [property]='property' (valueChange)='valueChange($event)' [readonly]='readonly'></e5core-ui-work-field-type-date-material>
  </span>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class E5coreUiWorkFieldTypeDateComponent extends E5coreUiWorkFieldTypeBase  implements OnInit {

  date : Date ;

  constructor(public style:UiStyleService, private cd:ChangeDetectorRef) {    
    super() ;
  }

  ngOnInit() {
		super.ngOnInit();
		this.workItem$.subscribe(
			wim => {
				if (this.property && this.property.value) {
          this.date = new Date(this.property.value) ;
          if(!(this.date instanceof Date)) {
            this.date = undefined ;
          }
        } else {
          this.date = undefined ;
        } ;
        this.cd.markForCheck() ;
      }      
		)
  }

  valueChange($event: WorkFieldDateChangeEvent) {
    this.dispatchPropertyChange(this.property.propertyId, $event.value.toJSON(), $event.error) ;
  }


  
}
